import React, { useState, useRef, useEffect, useContext } from 'react'
import { Layout, Row } from 'antd'
import PropTypes from 'prop-types'

import hamburger from '../../../icons/header/hamburger.svg'
import hamburgerOpen from '../../../icons/header/hamburger-open.svg'
import Axonslogo from '../../../icons/header/axons.svg'

import { LogoutOutlined, UserOutlined } from '@ant-design/icons'
import { UserActionTypes } from '../../../redux/user/user.types'
import { useMediaQuery } from 'react-responsive'
import { getCookie, removeCookieAll, setCookie } from '../../../helper/cookie'
import { useDispatch } from 'react-redux'
import { GET_DATA_ACCOUNT_BY_ID } from 'api/Account/profile'
import '../../../styleLess/signature/header.scss'
import styled from 'styled-components'
import { Button } from 'common/Button/button.styles'
import { Select } from 'antd'
import thailogo from 'icons/header/icons8-thailand-96.png'
import chinalogo from 'icons/header/icons8-china-96.png'
import endlandlogo from 'icons/header/icons8-england-96.png'
import { useHistory } from 'react-router-dom'
import { CounterContext } from 'redux/Golbalvalues'
import ModalSaveChange from 'common/Project/modalSaveChange'
import { getFileSecurityFromApi } from 'api/OpenFile'
import { LOGIN_AXONS_ONE } from 'config/env'
import { getAxonsOneSdk } from 'utils/axons-one-sdk'
import '@axons-library/portal-js-sdk/ninedotStyle'
const { Option } = Select

const { Header } = Layout
const NavStyle = styled.div``
const AXONS_ONE_NINEDOT_TARGET_ID = 'axons-one-ninedot-widget-target'
const AXONS_ONE_NINEDOT_WRAPPER_ID = 'axp-jssdk-ninedot-widget'
const isAxonsOneEnabled = LOGIN_AXONS_ONE === true || LOGIN_AXONS_ONE === 'true'
const HeaderComponents = (props) => {
  const userID = getCookie('userID')
  const token = getCookie('access_token_admin')
  const { counter, setDirty, isDirty, setClick_path, click_path, form } = useContext(
    CounterContext,
  )
  const boxRef = useRef(null)
  const btnRef = useRef(null)
  const axonsOneNineDotWidgetRef = useRef(null)
  const [isClicked, setIsClicked] = useState(false)
  const [isAxonsOneNineDotReady, setIsAxonsOneNineDotReady] = useState(false)
  const [isAxonsOneNineDotOpen, setIsAxonsOneNineDotOpen] = useState(false)
  const roleNameDefault = getCookie('roleNameDefault')
  const [visibleSaveChange, setVisibleSaveChange] = useState(false)
  useEffect(() => {
    function handleClickOutside(event) {
      if (btnRef.current && !btnRef.current.contains(event.target)) {
        if (boxRef.current && !boxRef.current.contains(event.target)) {
          setIsClicked(false)
        } else {
          setIsClicked(true)
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [boxRef])
  useEffect(() => {
    if (!isAxonsOneEnabled) {
      return undefined
    }

    let isMounted = true

    const setupAxonsOneNineDot = async () => {
      try {
        const axonsOneKit = getAxonsOneSdk()
        const authState = await axonsOneKit.init()

        if (!isMounted) {
          return
        }

        if (!authState?.activeSessionKey) {
          console.warn('Axons One nine-dot widget requires an active session')
          return
        }

        axonsOneNineDotWidgetRef.current = await axonsOneKit.initNineDotWidget(
          AXONS_ONE_NINEDOT_TARGET_ID,
        )

        if (isMounted) {
          setIsAxonsOneNineDotReady(true)
        }
      } catch (error) {
        console.error('Failed to initialize Axons One nine-dot widget:', error)
      }
    }

    setupAxonsOneNineDot()

    return () => {
      isMounted = false
      axonsOneNineDotWidgetRef.current?.close()
      axonsOneNineDotWidgetRef.current = null
    }
  }, [])
  const infoUserCookie = getCookie('infoUser')
  // ตรวจสอบว่าคุกกี้ 'infoUser' มีอยู่หรือไม่
  if (infoUserCookie) {
    try {
      const infoUser = JSON.parse(infoUserCookie)
      //const infoUser = JSON.parse(getCookie('infoUser'))
      const { collapsed, toggle, isMobielView } = props
      const dispatch = useDispatch()
      const [accountData, setAccountData] = useState([])
      const [modalIsOpen, setModalIsOpen] = useState(false)
      const lang111 = getCookie('lang')
      let aaaaa = ''
      let bbbbb = ''
      if (lang111 == 'en') {
        aaaaa = endlandlogo
        bbbbb = 'English'
      } else if (lang111 == 'th') {
        aaaaa = thailogo
        bbbbb = 'Thai'
      }
      const [iconlanguage, setIconlanguage] = useState(aaaaa)
      const [language, setLanguage] = useState(bbbbb)
      const history = useHistory()
      const onLogout = () => {
        try {
          dispatch({
            type: UserActionTypes.LOGOUT_SUCCESS,
            payload: '',
          })
          removeCookieAll()
          _refiner('resetUser')
          window.location.href = LOGIN_AXONS_ONE ? '/v2/login' : '/login'
        } catch (error) {
          console.log(error)
        }
      }
      const selectLanguage = (value) => {
        if (value === 'thai') {
          setIconlanguage(thailogo)
          setCookie('lang', 'th')
          window.location.reload()
          setLanguage('Thai')
        } else if (value === 'chineses') {
          setIconlanguage(chinalogo)
          setLanguage('Chineses')
        } else if (value === 'english') {
          setIconlanguage(endlandlogo)
          setLanguage('English')
          window.location.reload()
          setCookie('lang', 'en')
        }
      }
      const myprofilecomponents = () => {
        setIsClicked(false)
        history.push({
          pathname: '/myprofile',
        })
      }
      const closeAxonsOneNineDot = () => {
        axonsOneNineDotWidgetRef.current?.close()
        setIsAxonsOneNineDotOpen(false)
      }
      const showAxonsOneNineDot = () => {
        if (!axonsOneNineDotWidgetRef.current) {
          console.warn('Axons One nine-dot widget is not ready')
          return
        }

        axonsOneNineDotWidgetRef.current.show()
        setIsAxonsOneNineDotOpen(true)
      }
      const toggleAxonsOneNineDot = () => {
        if (isAxonsOneNineDotOpen) {
          closeAxonsOneNineDot()
          return
        }

        showAxonsOneNineDot()
      }
      useEffect(() => {
        if (!isAxonsOneNineDotOpen) {
          return undefined
        }

        const handleClickOutsideAxonsOneNineDot = (event) => {
          const triggerElement = document.getElementById(AXONS_ONE_NINEDOT_TARGET_ID)
          const widgetElement = document.getElementById(AXONS_ONE_NINEDOT_WRAPPER_ID)

          if (
            triggerElement?.contains(event.target) ||
            widgetElement?.contains(event.target)
          ) {
            return
          }

          closeAxonsOneNineDot()
        }

        document.addEventListener('mousedown', handleClickOutsideAxonsOneNineDot)
        return () => {
          document.removeEventListener('mousedown', handleClickOutsideAxonsOneNineDot)
        }
      }, [isAxonsOneNineDotOpen])
      const [imageUser, setImageuser] = useState(infoUser?.pic_display)

      const funcRefreshdataAccount = async () => {
        await GET_DATA_ACCOUNT_BY_ID({
          id: parseInt(userID),
          token: token,
        })
          .then(async (response) => {
            const { status, data, error } = response
            if (error) {
              await setAccountData([])
              return true
            }
            if (status === 200) {
              setAccountData(data)
              // if (data.pic_display != undefined && data.pic_display != '') {
              //   setImageuser(data.pic_display)
              // }
              if (data.pic_display != undefined && data.pic_display != '') {
                const response1 = await getFileSecurityFromApi({
                  url: data.pic_display,
                  token,
                }).then((res) => res.data)
                const blobUrl = URL.createObjectURL(response1)
                setImageuser(blobUrl)
              }
            } else {
              setAccountData([])
              return true
            }
          })
          .catch((error) => {
            setAccountData([])

            console.error(error)
          })
      }
      const modalSaveChange = () => {
        return (
          <ModalSaveChange
            form={form}
            visibleSaveChange={visibleSaveChange}
            setVisibleSaveChange={setVisibleSaveChange}
            path={click_path}
            setClick_path={setClick_path}
          />
        )
      }
      useEffect(() => {
        if (token) {
          funcRefreshdataAccount()
        }
      }, [token])
      useEffect(() => {
        if (counter != 0) {
          funcRefreshdataAccount()
        }
      }, [counter])

      return (
        <NavStyle>
          <div className="nav-desktop">
            <div className="nav-container">
              <div className="nav-container">
                <div className="navbar-hamburger" onClick={toggle}>
                  {collapsed ? (
                    <img src={hamburger} width={20} height={16} />
                  ) : (
                    <img src={hamburgerOpen} width={23} height={16} />
                  )}
                </div>
                <img className="nav-logo" src={Axonslogo} />
                <div className="nav-right-section">
                  <div className="noti-section">
                    <div className="avatar-item">
                      <Select
                        style={{ display: 'none' }}
                        onChange={selectLanguage}
                        size="large"
                        value={
                          <div
                            className="style-custom"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 4,
                              height: 38,
                            }}
                          >
                            <img style={{ width: 18 }} src={iconlanguage}></img>
                            <p>{language}</p>
                          </div>
                        }
                      >
                        <Option value="thai">Thai</Option>
                        <Option value="english">English</Option>
                      </Select>
                    </div>
                  </div>
                  <div>
                    <div className="avatar-section">
                      <Row
                        className="show-name-and-role"
                        style={{
                          alignItems: 'end',
                          flexDirection: 'column-reverse',
                          justifyContent: 'flex-start',
                        }}
                      >
                        <span className="small">{roleNameDefault}</span>
                        <div className="text-darkgrey1">
                          {infoUser?.firstname} {infoUser?.lastname}
                        </div>
                      </Row>
                      <img
                        className="nav-avatar"
                        src={imageUser}
                        onClick={(e) => setIsClicked(!isClicked)}
                        ref={btnRef}
                      />

                      <div
                        className={isClicked ? 'logout-custom' : 'active-logout-custom'}
                        ref={boxRef}
                      >
                        <div className="popOver">
                          <div className="box-img-text">
                            <img className="img-style" src={imageUser}></img>
                            <div className="box-text">
                              <div style={{ display: 'grid' }}>
                                <h3 className="cutter-text-line-1">
                                  {infoUser?.firstname} {infoUser?.lastname}
                                </h3>
                              </div>
                              <div style={{ display: 'grid' }}>
                                <p className="cutter-text-line-1">{infoUser?.email}</p>
                              </div>
                            </div>
                          </div>
                          <div className="bottom-container-popover">
                            <Button
                              type="primary"
                              className="BTN_Previous"
                              onClick={() => {
                                isDirty
                                  ? setVisibleSaveChange(true)
                                  : myprofilecomponents(),
                                  isDirty ? setClick_path('/myprofile') : setClick_path()
                              }}
                            >
                              <UserOutlined className="Icon-color" />
                              View Profile
                            </Button>
                            <Button className="btn_Secondary2" onClick={() => onLogout()}>
                              <LogoutOutlined className="Icon-color" />
                              Log Out
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {isAxonsOneEnabled && (
                    <button
                      id={AXONS_ONE_NINEDOT_TARGET_ID}
                      type="button"
                      className="axons-one-widget-trigger"
                      onClick={toggleAxonsOneNineDot}
                      disabled={!isAxonsOneNineDotReady}
                      aria-label="Open Axons One apps"
                      title={
                        isAxonsOneNineDotReady
                          ? 'Open Axons One apps'
                          : 'Axons One session is not ready'
                      }
                    >
                      <span className="axons-one-nine-dot-icon" aria-hidden="true">
                        {Array.from({ length: 9 }).map((_, index) => (
                          <span key={index} />
                        ))}
                      </span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {modalSaveChange()}
        </NavStyle>
      )
    } catch (error) {
      console.error('Error parsing JSON:', error)
    }
  } else {
    removeCookieAll()
    window.location.href = LOGIN_AXONS_ONE ? '/v2/login' : '/login'
  }
}

HeaderComponents.propTypes = {
  collapsed: PropTypes.bool,
  toggle: PropTypes.func,
  isMobielView: PropTypes.bool,
}

HeaderComponents.defaultProps = {
  collapsed: true,
  toggle: () => {},
  isMobielView: false,
}

export default HeaderComponents
